import { Injectable } from "@angular/core";

import { QueryStringParameterKey } from "../routes/shared/shared-route.constant";

@Injectable({ providedIn: "root" })
export class AttributionCodeExtractorService {
  tryGetAttributionCode(url: URL) {
    const urlSearchParams = url.searchParams;

    const attributionCode =
      urlSearchParams.get(QueryStringParameterKey.ATTRIBUTION_CODE) ??
      undefined;

    return attributionCode;
  }
}
